export { default as VehiclePartCompatibilityQuery } from './VehiclePartCompatibilityQuery';
export { default as VehicleDataQuery } from './VehicleDataQuery';
export { default as PlateDataQuery } from './PlateDataQuery';